import React from 'react';
import { Box, Typography } from '@/ui';

interface RouteItem { key: string; label: string }

interface InnerNavDesktopProps {
  routes: Array<RouteItem>;
  selectedKey: string;
  onSelect: (key: string) => void;
}

const InnerNavDesktop: React.FC<InnerNavDesktopProps> = ({ routes, selectedKey, onSelect }) => {
  return (
    <Box sx={{
      display: 'flex',
      gap: 4,
      flexWrap: 'nowrap',
      overflowX: 'auto',
      flex: 1,
      // Hide scrollbar while keeping scroll functionality
      scrollbarWidth: 'none', // Firefox
      msOverflowStyle: 'none', // IE and Edge
      '&::-webkit-scrollbar': {
        display: 'none' // Chrome, Safari, Opera
      }
    }}>
      {routes.map((route) => (
        <Box
          key={route.key}
          onClick={() => onSelect(route.key)}
          sx={{
            cursor: 'pointer',
            display: 'flex',
            flexDirection: 'column',
            gap: 0.5,
            py: 0.5
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: selectedKey === route.key ? 'text.primary' : '#616161',
              fontSize: '16px',
              whiteSpace: 'nowrap',
              fontWeight: 400,
              lineHeight: '24px',
              '&:hover': {
                color: 'text.primary',
              },
            }}
          >
            {route.label}
          </Typography>
          {selectedKey === route.key && (
            <Box sx={{
              height: '2px',
              backgroundColor: 'text.primary',
              width: '100%',
              borderRadius: '1px'
            }} />
          )}
        </Box>
      ))}
    </Box>
  );
};

export default InnerNavDesktop;


